import { Actions, ActionTypes } from './actions';
import { adapter, initialState, ServiceCatalogState } from './state';

export function reducer(state = initialState, action: Actions): ServiceCatalogState {
  switch (action.type) {
    case ActionTypes.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case ActionTypes.GET_ALL_REQUEST:
    case ActionTypes.ENABLE_REQUEST:
    case ActionTypes.DISABLE_REQUEST:
    case ActionTypes.SYNC_REQUEST:
    case ActionTypes.FILTER_REQUEST:
    case ActionTypes.UPLOAD_CATEGORY_ICON_REQUEST:
    case ActionTypes.DELETE_CATEGORY_ICON_REQUEST:
    case ActionTypes.UPDATE_SERVICE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case ActionTypes.GET_ALL_SUCCESS:
      return adapter.setAll(action.entities, {
        ...state,
        isLoading: false,
        error: null,
      });
    case ActionTypes.ENABLE_SUCCESS:
      return adapter.upsertMany(action.entities, {
        ...state,
        isLoading: false,
        error: null,
      });
    case ActionTypes.DISABLE_SUCCESS:
      return adapter.upsertMany(action.entities, {
        ...state,
        isLoading: false,
        error: null,
      });
    case ActionTypes.FILTER_SUCCESS:
      return {
        ...state,
        filtered: [...action.entities],
        isLoading: false,
        error: null,
      };
    case ActionTypes.UPDATE_SERVICE_SUCCESS:
      return adapter.upsertOne(action.entity, {
        ...state,
        isLoading: false,
        error: null,
      });

    default:
      return state;
  }
}
